import LTR from "@brand-icons/ploomg4/hand-choose/hand-choose-ltr.svg";

import { iconFactory } from "../iconFactory";

export const HandChooseIcon = iconFactory("HandChooseIcon", LTR);
